exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-row[data-v-af2c9e74]{margin-bottom:20px\n}\n.full-width[data-v-af2c9e74]{width:100%\n}\n", "", {"version":3,"sources":["/app/frontend/src/screens/central/cadastros/maranhao/processoFisico/components/MatriculaTituloImovel.vue"],"names":[],"mappings":";AAmHA,yBACE,kBAAmB;CACpB;AAAA,6BAGC,UAAW;CACZ","file":"MatriculaTituloImovel.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.el-row {\n  margin-bottom: 20px;\n}\n\n.full-width {\n  width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-af2c9e74","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/central/cadastros/maranhao/processoFisico/components/MatriculaTituloImovel.vue
// module id = aOqU
// module chunks = 11